(() => {
  if (window.barewayReferencePdpLoaded) return;
  window.barewayReferencePdpLoaded = true;
  const number = value => Number(String(value).trim().replace(',', '.'));
  function readChart(table) {
    if (!table) return [];
    const headers = [...table.rows[0].cells].map(cell => cell.textContent.trim().toLowerCase());
    const index = pattern => headers.findIndex(value => pattern.test(value));
    const columns = {eu:index(/^eu$/),uk:index(/^uk$/),us:index(/^us(?: men| male| masculino)?$/),women:index(/^us women/),cm:index(/cm/)};
    if (columns.us < 0 || columns.cm < 0) return [];
    return [...table.rows].slice(1).map(row => {
      const get = name => columns[name] < 0 ? null : number(row.cells[columns[name]]?.textContent);
      return {eu:get('eu'),uk:get('uk'),us:get('us'),women:get('women'),cm:get('cm')};
    }).filter(row => Number.isFinite(row.us) && row.us > 0 && Number.isFinite(row.cm) && row.cm > 0);
  }
  function initialise(section) {
    const panel = section.querySelector('[data-bw-reference-after]');
    if (!panel || panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const info = section.querySelector('.product__info-container');
    const variants = JSON.parse(panel.querySelector('[data-bw-reference-variants]').textContent);
    const chart = panel.querySelector('[data-bw-reference-chart]');
    const originalTable = chart?.querySelector('table');
    const general = readChart(panel.querySelector('[data-bw-general-chart]')?.content.querySelector('table'));
    const rows = readChart(originalTable);
    rows.forEach(row => {
      const match = general.find(other => other.us === row.us);
      if (match) { row.eu ??= match.eu; row.uk ??= match.uk; }
    });
    if (['strutters','roamers'].includes(panel.dataset.productHandle) && rows.length && !rows.some(row => row.us === 15)) rows.push({eu:null,uk:null,us:15,women:16,cm:30.5});
    if (originalTable && rows.length) {
      const table = document.createElement('table');
      const head = table.createTHead().insertRow();
      ['EU','UK','US','CM','INCHES'].forEach(label => { const th=document.createElement('th');th.scope='col';th.textContent=label;head.append(th); });
      const body = table.createTBody();
      rows.forEach(data => {
        const row = body.insertRow();row.dataset.us=String(data.us);row.dataset.eu=String(data.eu ?? '');
        [data.eu,data.uk,data.us,data.cm,(data.cm/2.54).toFixed(1)].forEach((value,index)=>{const cell=document.createElement(index===0?'th':'td');if(index===0)cell.scope='row';cell.textContent=value == null ? '—' : String(value);row.append(cell);});
      });
      chart.replaceChildren(table);
    }
    const getPicker = () => section.querySelector('variant-selects');
    const sizeSelect = () => getPicker()?.querySelector('.bareway-size-picker select');
    const matchingRow = value => {
      const source=String(value||'');
      if(panel.dataset.sizeSystem==='EU')return rows.find(row=>row.eu===number(source.replace(/EU\s*/i,'')));
      const match=source.match(/(?:^|\/)\s*M\s*(\d+(?:\.\d+)?)/i);
      if(match)return rows.find(row=>row.us===number(match[1]));
      const us=source.match(/^US\s*(\d+(?:\.\d+)?)/i);
      return us ? rows.find(row=>row.us===number(us[1])) : null;
    };
    function update() {
      const select = sizeSelect();
      if(select) {
        [...select.options].forEach(option=>{
          const row=matchingRow(option.value);
          if(!row)return;
          const label=[`US ${row.us}`,row.uk==null?null:`UK ${row.uk}`,row.eu==null?null:`EU ${row.eu}`].filter(Boolean).join(' / ');
          if(option.textContent.trim()!==label)option.textContent=label;
        });
        const current=matchingRow(select.value);
        chart?.querySelectorAll('tbody tr').forEach(row=>row.classList.toggle('bw-ref-selected',!!current&&number(row.dataset.us)===current.us));
      }
      const picker=getPicker();
      const fields=picker?[...picker.querySelectorAll('.product-form__input')]:[];
      const chosen=fields.map(field=>field.querySelector('select')?.value ?? field.querySelector('input[type="radio"]:checked')?.value).filter(value=>value!==undefined);
      const variant=chosen.length?variants.find(v=>v.options.every((value,index)=>value===chosen[index])):variants.find(v=>v.id===Number(info.querySelector('product-form [name="id"]')?.value));
      const status=panel.querySelector('[data-bw-stock-status]');
      const copy=panel.querySelector('[data-bw-stock-copy]');
      const next=variant?.available?panel.dataset.inStock:variant?panel.dataset.soldOut:panel.dataset.unavailable;
      if(copy.textContent!==next)copy.textContent=next;
      if(variant?.available)status.removeAttribute('data-unavailable');else status.setAttribute('data-unavailable','true');
    }
    let queued=false;
    const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update();});};
    const picker=getPicker();
    if(picker){picker.addEventListener('change',schedule);new MutationObserver(schedule).observe(picker,{subtree:true,childList:true});}
    section.addEventListener('click',event=>{
      const opener=event.target.closest('[data-bw-reference-guide]');
      if(opener){const dialog=document.getElementById(opener.dataset.bwReferenceGuide);if(dialog&&!dialog.open){update();dialog.showModal();}}
      const close=event.target.closest('[data-bw-reference-close]');if(close)close.closest('dialog').close();
    });
    panel.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}}));
    update();
  }
  const boot = () => document.querySelectorAll('section[id^="MainProduct-"]:has(.bw-ref-after)').forEach(initialise);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
  document.addEventListener('shopify:section:load',boot);
})();
